interface PersistedTreeState {
  selectedNodesIds: string[];
  currentNodeId: string;
}

const getStateKey = (userId: number): string => `MedsafeTreeState-${userId}`;

export function saveTreeState(
  selectedNodesIds: string[],
  currentNodeId: string,
  userId: number,
): void {
  try {
    if (!userId) return;

    const state: PersistedTreeState = {
      selectedNodesIds,
      currentNodeId,
    };

    localStorage.setItem(getStateKey(userId), JSON.stringify(state));
  } catch (error) {
    console.error(error);
  }
}

export function restoreTreeState(
  userId: number,
): PersistedTreeState | null {
  try {
    if (!userId) return null;

    const stored = localStorage.getItem(getStateKey(userId));
    if (!stored) return null;

    const state = JSON.parse(stored) as PersistedTreeState;
    if (
      !Array.isArray(state.selectedNodesIds)
      || typeof state.currentNodeId !== 'string'
    ) {
      return null;
    }

    return state;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export function clearTreeState(userId: number): void {
  try {
    if (!userId) return;
    localStorage.removeItem(getStateKey(userId));
  } catch (error) {
    console.error(error);
  }
}
